import React from 'react';

export default function NoResultsNotice(props) {
    return <div className="no-results-notice">{props.children}</div>;
}
